import React from 'react';
import ContainerComponent from '../../helpers/components/container.component';
import PageHeaderComponent from '../../helpers/components/page_header.component';
import CountListTable from './components/count_list_table';

const CountList = () => {
    return (
        <>
            <ContainerComponent span={22} top={20}>
                <PageHeaderComponent />
                <CountListTable />
            </ContainerComponent>
        </>
    );
}

export default CountList;